import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { StackType, WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { isMobile } from "../../../configs/utils";
import { heightMap } from "../../../configs/height";
import { ACTION } from "./types";
import { goBack, onLanguageSelected, onResetFilter } from "./action";
const _isMobile = isMobile();
export const template = async (height, collateralData, filtersSelected) => ({
    layout: {
        id: ROUTE.COLLATERAL_LANGUAGE_SELECT,
        type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.RIGHT,
            height: heightMap[ROUTE.COLLATERAL_LANGUAGE_SELECT]
        },
        widgets: [{ id: 'collateralFilterLanguageStack', type: WIDGET.STACK }],
    },
    datastore: {
        collateralFilterLanguageStack: {
            type: StackType.column,
            widgetItems: [
                { id: "collateralLanguageFilterSelect", type: WIDGET.COLLATERAL_LANGUAGE_FILTER_SELECT }
            ]
        },
        collateralLanguageFilterSelect: {
            collateralData: collateralData,
            height: height,
            onBackPressAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.COLLATERAL_LANGUAGE_SELECT,
                payload: {}
            },
            onLanguageSelected: {
                type: ACTION.ON_LANGUAGE_SELECTED,
                routeId: ROUTE.COLLATERAL_LANGUAGE_SELECT,
                payload: {}
            },
            filtersSelected: filtersSelected,
            counter: Math.random(),
            onResetFilterAction: {
                type: ACTION.RESET_FILTER,
                routeId: ROUTE.COLLATERAL_LANGUAGE_SELECT,
                payload: {}
            }
        },
    },
});
export const collateralLanguageSelectMF = {
    onLoad: async ({ getHeight, removeWidgets }, { collateralListData, filtersSelected }) => {
        return Promise.resolve(template(getHeight(), collateralListData, filtersSelected));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.ON_LANGUAGE_SELECTED]: onLanguageSelected,
        [ACTION.RESET_FILTER]: onResetFilter,
    }
};
